const expenseComponentLoaders = Object.freeze({
  'expense.expense-workspace': async () => {
    const module = await import('./expense-workspace-component.js');
    return module.ExpenseWorkspaceComponent;
  },
});

export default expenseComponentLoaders;
